<div class="">
<div class="container ">


  <!--Section: Content-->
  <section class="dark-grey-text">

    <div class="row pr-lg-5">
      <div class="col-md-7 mb-4">

        <div class="view">
          <img src="assets/images/commerce.png" class="img-fluid" alt="smaple image">
        </div>

      </div>
      <div class="col-md-5 d-flex align-items-center">
        <div>
          
          <h3 class="font-weight-bold mb-4">Material Design Blocks</h3>

        	<p>Lorem ipsum dolor sit amet consectetur adip elit. Maiores deleniti explicabo voluptatem quisquam nulla asperiores aspernatur aperiam voluptate et consectetur minima delectus, fugiat eum soluta blanditiis adipisci, velit dolore magnam.</p>

        	<button type="button" class="btn btn-orange btn-rounded mx-0">Download</button>

        </div>
      </div>
    </div>

  </section>
  <!--Section: Content-->
</div>

</div>

  <div class="container my-5 py-5">


    <!--Section: Content-->
    <section class="text-center">


      <!--Grid row-->
      <div class="row">

        <!--Grid column-->
        <div class="col-lg-4 col-md-12 mb-4">

          <!-- Card -->
          <div class="card">

            <!-- Card image -->
            <div class="view overlay">
              <img class="card-img-top" src="https://mdbootstrap.com/img/Photos/Horizontal/E-commerce/Products/shoes%20(6).jpg"
                alt="Card image cap">
              <a href="#!">
                <div class="mask rgba-white-slight"></div>
              </a>
            </div>

            <!-- Card content -->
            <div class="card-body">

              <p class="mb-1"><a href="" class="font-weight-bold black-text">Adidas Air Max</a></p>

              <p class="mb-1"><small class="mr-1"><s>$299</s></small><strong>$99</strong></p>

              <div class="amber-text fa-xs mb-1">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="far fa-star"></i>
              </div>

              <button type="button" class="btn btn-black btn-rounded btn-sm px-3">Buy Now</button>
              <button type="button" class="btn btn-outline-black btn-rounded btn-sm px-3 waves-effect">Details</button>

            </div>

          </div>
          <!-- Card -->


        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4">

          <!-- Card -->
          <div class="card">

            <!-- Card image -->
            <div class="view overlay">
              <img class="card-img-top" src="https://mdbootstrap.com/img/Photos/Horizontal/E-commerce/Products/shoes%20(7).jpg"
                alt="Card image cap">
              <a href="#!">
                <div class="mask rgba-white-slight"></div>
              </a>
            </div>

            <!-- Card content -->
            <div class="card-body">

              <p class="mb-1"><a href="" class="font-weight-bold black-text">Vans Black Night</a></p>

              <p class="mb-1"><small class="mr-1"><s>$199</s></small><strong>$89</strong></p>

              <div class="amber-text fa-xs mb-1">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
              </div>

              <button type="button" class="btn btn-black btn-rounded btn-sm px-3">Buy Now</button>
              <button type="button" class="btn btn-outline-black btn-rounded btn-sm px-3 waves-effect">Details</button>

            </div>

          </div>
          <!-- Card -->

        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4">

          <!-- Card -->
          <div class="card">

            <!-- Card image -->
            <div class="view overlay">
              <img class="card-img-top" src="https://mdbootstrap.com/img/Photos/Horizontal/E-commerce/Products/shoes%20(8).jpg"
                alt="Card image cap">
              <a href="#!">
                <div class="mask rgba-white-slight"></div>
              </a>
            </div>

            <!-- Card content -->
            <div class="card-body">

              <p class="mb-1"><a href="" class="font-weight-bold black-text">Nike Football</a></p>

              <p class="mb-1"><small class="mr-1"><s>$399</s></small><strong>$199</strong></p>

              <div class="amber-text fa-xs mb-1">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star-half-alt"></i>
              </div>

              <button type="button" class="btn btn-black btn-rounded btn-sm px-3">Buy Now</button>
              <button type="button" class="btn btn-outline-black btn-rounded btn-sm px-3 waves-effect">Details</button>

            </div>

          </div>
          <!-- Card -->

        </div>
        <!--Grid column-->

      </div>
      <!--Grid row-->


    </section>
    <!--Section: Content-->


  </div>
  
  <!-- Section: Block Content -->
<section>

    <!-- Carousel Wrapper -->
    <div id="carousel-example-3" class="carousel slide carousel-fade" data-ride="carousel">
      <!-- Indicators -->
      <ol class="carousel-indicators">
        <li data-target="#carousel-example-3" data-slide-to="0" class="active"></li>
        <li data-target="#carousel-example-3" data-slide-to="1"></li>
        <li data-target="#carousel-example-3" data-slide-to="2"></li>
      </ol>
      <!-- Indicators -->
      <!-- Slides -->
      <div class="carousel-inner" role="listbox">
        <div class="carousel-item active">
          <div class="view">
            <a href="#!">
                <img class="d-block w-100" src="https://mdbootstrap.com/img/Photos/Others/ecommerce4.jpg" alt="First slide">
                <div class="mask rgba-white-slight text-center d-flex align-items-center justify-content-center">
                  <div class="row">
                    <div class="col-12">
                      <p class="h1-responsive red-text font-weight-bold mb-0">Sale off 30% on every saturday!</p>
                    </div>
                  </div>
                </div>
                 </a>
          </div>
        </div>
        <div class="carousel-item">
          <!-- Mask color -->
          <div class="view">
            <a>
                <img class="d-block w-100" src="https://mdbootstrap.com/img/Photos/Others/ecommerce2.jpg" alt="Second slide">
                <div class="mask rgba-white-slight text-center d-flex align-items-center justify-content-center">
                  <div class="row">
                    <div class="col-12">
                      <p class="h1-responsive indigo-text font-weight-bold mb-0">Promotion on each smartphone!</p>
                    </div>
                  </div>
                </div>
            </a>
          </div>
        </div>
        <div class="carousel-item">
          <!-- Mask color -->
          <div class="view">
            <a>
                <img class="d-block w-100" src="https://mdbootstrap.com/img/Photos/Others/ecommerce3.jpg" alt="Third slide">
                <div class="mask rgba-white-slight text-center d-flex align-items-center justify-content-center">
                  <div class="row">
                    <div class="col-12">
                      <p class="h1-responsive orange-text font-weight-bold mb-0">Sale off 20% on every headphones!</p>
                  </div>
                  </div>
                </div>
            </a>
          </div>
        </div>
      </div>
      <!-- Slides -->
      <!-- Controls -->
      <a class="carousel-control-prev" href="#carousel-example-3" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carousel-example-3" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
      <!-- Controls -->
    </div>
    <!-- Carousel Wrapper -->
  
  </section>
  <!-- Section: Block Content -->

  <div class="container z-depth-1 my-5 p-5">

    <!-- Section -->
    <section>
      
          <h3 class="font-weight-bold text-center dark-grey-text pb-2">A Few Easy Steps</h3>
      <hr class="w-header my-4">
      <p class="lead text-center text-muted pt-2 pb-3 mb-5">We are so proud of our product. It's really easy to create a landing page for your product.</p>
  
      <div class="row dark-grey-text">
  
        <div class="col-md-6 col-xl-4 mb-4">
          <div class="media">
            <div class="mr-4">
              <span class="text-primary"><i class="icon-fa fas fa-file-alt fa-2x"></i></span>
            </div>
            <div class="media-body">
              <h6 class="font-weight-bold">Step One</h6>
              <p class="text-muted">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium eaque ipsa doloremque laudantium.</p>
            </div>
          </div>
        </div>
  
        <div class="col-md-6 col-xl-4 mb-4">
          <div class="media">
            <div class="mr-4">
              <span class="text-danger"><i class="icon-fa fas fa-bullhorn fa-2x"></i></span>
            </div>
            <div class="media-body">
              <h6 class="font-weight-bold">Step Two</h6>
              <p class="text-muted">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium eaque ipsa doloremque laudantium.</p>
            </div>
          </div>
        </div>
  
        <div class="col-md-6 col-xl-4 mb-4">
          <div class="media">
            <div class="mr-4">
              <span class="text-info"><i class="icon-fa fas fa-code fa-2x"></i></span>
            </div>
            <div class="media-body">
              <h6 class="font-weight-bold">Step Three</h6>
              <p class="text-muted">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium eaque ipsa doloremque laudantium.</p>
            </div>
          </div>
        </div>
  
        <div class="col-md-6 col-xl-4 mb-4">
          <div class="media">
            <div class="mr-4">
              <span class="text-warning"><i class="icon-fa fas fa-comments fa-2x"></i></span>
            </div>
            <div class="media-body">
              <h6 class="font-weight-bold">Step Four</h6>
              <p class="text-muted">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium eaque ipsa doloremque laudantium.</p>
            </div>
          </div>
        </div>
  
        <div class="col-md-6 col-xl-4 mb-4">
          <div class="media">
            <div class="mr-4">
              <span class="text-muted"><i class="icon-fa fas fa-cogs fa-2x"></i></span>
            </div>
            <div class="media-body">
              <h6 class="font-weight-bold">Step Five</h6>
              <p class="text-muted">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium eaque ipsa doloremque laudantium.</p>
            </div>
          </div>
        </div>
  
        <div class="col-md-6 col-xl-4 mb-4">
          <div class="media">
            <div class="mr-4">
              <span class="text-success"><i class="icon-fa far fa-handshake fa-2x"></i></span>
            </div>
            <div class="media-body">
              <h6 class="font-weight-bold">Step Six</h6>
              <p class="text-muted">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium eaque ipsa doloremque laudantium.</p>
            </div>
          </div>
        </div>
  
      </div>
  
    </section>
    <!-- Section -->
    
  </div>

  